import { defaultDocumentType } from '@constants/regions';
import { axiosInstance } from '@services/base-service';

const onboardingUri = '/merchant/bff/onboarding';

export const updateMerchant = async (data, callbackSuccess, callbackError) => {
  try {
    await axiosInstance
      .getInstance()
      .post(`${onboardingUri}/merchant/update`, { payload: data }, { hasAuthorization: false })
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const getMerchantData = async (hash, callbackSuccess, callbackError) => {
  try {
    await axiosInstance
      .getInstance()
      .get(`${onboardingUri}/merchant/${hash}`, { hasAuthorization: false })
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const isMerchantRut = async (data, callbackSuccess, callbackError) => {
  try {
    await axiosInstance
      .getInstance()
      .get(`${onboardingUri}/merchant/${data.doc_type || defaultDocumentType}/${data.doc_number}`, {
        hasAuthorization: false,
      })
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const getGirosPerCountry = async (callbackSuccess, callbackError) => {
  try {
    await axiosInstance
      .getInstance()
      .get(`${onboardingUri}/activity`, {
        headers: {
          'x-flow-locale': 'es-CL',
        },
        hasAuthorization: false,
      })
      .then(
        (response) => callbackSuccess(response.activity),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const createLegalEntityAccount = async (data, callbackSuccess, callbackError) => {
  try {
    await axiosInstance
      .getInstance()
      .post(
        `${onboardingUri}/merchant/legal-entity`,
        { payload: data },
        { hasAuthorization: false }
      )
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const createPersonAccount = async (data, callbackSuccess, callbackError) => {
  try {
    await axiosInstance
      .getInstance()
      .post(`${onboardingUri}/merchant/person`, { payload: data }, { hasAuthorization: false })
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const resendMail = async (mail, callbackSuccess, callbackError) => {
  try {
    await axiosInstance
      .getInstance()
      .get(`${onboardingUri}/resend-mail/${mail}`, { hasAuthorization: false })
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const createPassword = async (data, callbackSuccess, callbackError) => {
  try {
    await axiosInstance
      .getInstance()
      .post(`${onboardingUri}/merchant/password`, { payload: data }, { hasAuthorization: false })
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const uploadUserFiles = async (data, callbackSuccess, callbackError) => {
  const formData = data.fileList || new FormData();
  try {
    await axiosInstance
      .getInstance()
      .patch(`${onboardingUri}/merchant/documents`, formData, {
        headers: {
          'content-type': 'multipart/form-data',
        },
        hasAuthorization: false,
      })
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const validateEmail = async (data, callbackSuccess, callbackError) => {
  try {
    await axiosInstance
      .getInstance()
      .post(`${onboardingUri}/merchant/email/validate/${data.token}`, {
        hasAuthorization: false,
      })
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const getTerms = async (callbackSuccess, callbackError) => {
  try {
    await axiosInstance
      .getInstance()
      .get(`${onboardingUri}/terms`, {
        headers: { 'x-flow-service': 'merchant' },
        hasAuthorization: false,
      })
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const getPrivacity = async (callbackSuccess, callbackError) => {
  try {
    await axiosInstance
      .getInstance()
      .get(`${onboardingUri}/privacy-policy`, {
        headers: { 'x-flow-service': 'pp-merchant' },
        hasAuthorization: false,
      })
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const validateTokenByProfileId = (payload) =>
  axiosInstance.getInstance().post(
    `${onboardingUri}/merchant/user-profile/validate`,
    { payload },
    {
      headers: { 'x-flow-service': 'pp-merchant' },
      hasAuthorization: false,
    }
  );

export const createPasswordAndes = (payload) =>
  axiosInstance.getInstance().post(
    `${onboardingUri}/merchant/create-password-tyc-andes`,
    { payload },
    {
      headers: { 'x-flow-service': 'pp-merchant' },
      hasAuthorization: false,
    }
  );
